import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { MenuComponent } from 'src/app/components/base/menu/menu.component';
import { ProductDetailsComponent } from 'src/app/components/order/product-details/product-details.component';
import { GoogleContactComponent } from 'src/app/components/contact/google-contact/google-contact.component';
import { ProductSelectorComponent } from 'src/app/components/order/product-selector/product-selector.component';
import { TestModalComponent } from 'src/app/components/test-modal/test-modal.component';
import { OrderDetailsComponent } from 'src/app/components/order/order-details/order-details.component';
import { CurrentOrderComponent } from 'src/app/components/order/current-order/current-order.component';
import { LexwareContactComponent } from 'src/app/components/contact/lexware-contact/lexware-contact.component';
import { ChangeAddressComponent } from 'src/app/components/order/change-address/change-address.component';
import { ConvertContactComponent } from 'src/app/components/contact/convert-contact/convert-contact.component';
import { OrderOverviewComponent } from 'src/app/components/order/order-overview/order-overview.component';
import { DeliveryManagerComponent } from 'src/app/components/order/delivery-manager/delivery-manager.component';
import { OrderHistoryComponent } from 'src/app/components/order/order-history/order-history.component';
import { OrderCommentsComponent } from 'src/app/components/order/order-comments/order-comments.component';
import { ImageLightboxComponent } from 'src/app/components/order/image-lightbox/image-lightbox.component';
import { ProductFilterSheetComponent } from 'src/app/components/order/product-filter-sheet/product-filter-sheet.component';
import { BarcodeScanOverlayComponent } from 'src/app/components/order/barcode-scan-overlay/barcode-scan-overlay.component';
import { KarmaUnavailableBadgeComponent } from 'src/app/components/order/karma-unavailable-badge/karma-unavailable-badge.component';

import { GroupByPipe } from 'src/app/pipe/groupby.pipe';

@NgModule({
  declarations: [
    MenuComponent,
    ProductDetailsComponent,
    GoogleContactComponent,
    ProductSelectorComponent,
    TestModalComponent,
    OrderDetailsComponent,
    CurrentOrderComponent,
    LexwareContactComponent,
    ChangeAddressComponent,
    ConvertContactComponent,
    OrderOverviewComponent,
    DeliveryManagerComponent,
    OrderHistoryComponent,
    OrderCommentsComponent,
    ImageLightboxComponent,
    ProductFilterSheetComponent,
    BarcodeScanOverlayComponent,
    KarmaUnavailableBadgeComponent,
  ],
  imports: [FormsModule, CommonModule, IonicModule, GroupByPipe, ScrollingModule],
  exports: [
    ScrollingModule,
    MenuComponent,
    ProductDetailsComponent,
    GoogleContactComponent,
    ProductSelectorComponent,
    TestModalComponent,
    OrderDetailsComponent,
    CurrentOrderComponent,
    LexwareContactComponent,
    ChangeAddressComponent,
    ConvertContactComponent,
    OrderOverviewComponent,
    DeliveryManagerComponent,
    OrderHistoryComponent,
    OrderCommentsComponent,
    ImageLightboxComponent,
    ProductFilterSheetComponent,
    BarcodeScanOverlayComponent,
    KarmaUnavailableBadgeComponent,
  ],
})
export class SharedModule {}
